import { useContext, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import StartNumbersContext from '../../../../contexts/StartNumbersContext';
import RaceClassTag from './RaceClassTag';
import RaceClassAdder from './RaceClassAdder';

const StartNumbersRow = ({ data }) => {
  const {
    addClass,
    removeClass,
    removeStartNumberGroup,
    startNumberGroups,
    updateStartNumber,
    startList,
  } = useContext(StartNumbersContext);

  const participantsCount = useMemo(() => {
    return startList.filter((participant) => {
      return data.raceClasses
        .map((raceClass) => raceClass.Id)
        .includes(participant.raceClassString);
    }).length;
  }, [data.raceClasses, startList]);

  const gapToNext = useMemo(() => {
    const index = startNumberGroups.findIndex((group) => group.id === data.id);
    try {
      const next = startNumberGroups[index + 1];
      return next.startNumber - data.startNumber - participantsCount;
    } catch (err) {
      return undefined;
    }
  }, [data, startNumberGroups, participantsCount]);

  return (
    <tr key={data.id} className='bg-white'>
      {/* Race classes */}
      <td>
        <div className='d-flex flex-wrap gap-2'>
          {data.raceClasses.map((raceClass) => (
            <RaceClassTag
              key={raceClass.Id}
              onDelete={() => removeClass(data.id, raceClass)}
            >
              {raceClass.Label}
            </RaceClassTag>
          ))}
          <RaceClassAdder onAdd={(value) => addClass(data.id, value, participantsCount)} />
        </div>
      </td>

      {/* Number of participants */}
      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
        <span>{participantsCount}</span>
      </td>

      {/* Input start number */}
      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
        <Form.Control
          type='number'
          value={data.startNumber}
          onChange={(ev) => updateStartNumber(data.id, ev.target.value)}
          style={{ width: '10ch', textAlign: 'center', margin: 'auto' }}
        />
      </td>

      {/* Gap to next start number */}
      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
        {gapToNext ?? '-'}
      </td>

      {/* Delete button */}
      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
        <button
          className='btn-close'
          style={{ fontSize: '18px' }}
          onClick={() => removeStartNumberGroup(data.id)}
        />
      </td>
    </tr>
  );
};

export default StartNumbersRow;
